import { format } from "date-fns";
import { DailySummaryRecipient } from "./daily_summary_recipient";

export class DailySummaryRecipients extends Array<DailySummaryRecipient> {
  constructor(dailySummaryRecipients?: DailySummaryRecipient[]) {
    super();
    if (dailySummaryRecipients instanceof Array) {
      dailySummaryRecipients.forEach((dailySummaryRecipient) =>
        this.push(dailySummaryRecipient),
      );
    }
  }

  get local_last_updated_at(): Date | undefined {
    return this.length === 0
      ? undefined
      : this.map((dailySummaryRecipient) =>
          dailySummaryRecipient.created_at
            ? new Date(dailySummaryRecipient.created_at)
            : undefined,
        ).sort((a, b) => (b?.getTime() ?? 0) - (a?.getTime() ?? 0))[0];
  }

  get local_last_updated_at_datetime_string(): string | undefined {
    if (!this.local_last_updated_at) return undefined;
    return format(this.local_last_updated_at, "MMM d, hh:mm aaa");
  }
}
